import React from 'react';
import styles from './Verbatim.module.scss';

export default function Verbatim({title, text, source}) {
    return (
            <div className={styles.Verbatim}>
                <span className={styles.Title}>{title}</span>

                <p className={[styles.Text, 'large'].join(' ')}
                   dangerouslySetInnerHTML={{__html: text}}/>

                {source ? <strong>Source : {source}</strong> : null}
            </div>
    );
}